
import React from "react";
import { useNavigate } from "react-router-dom";
import "../../../Styles/insights/InsightsNovac.css";

export default function InsightsNovac() {
    const navigate = useNavigate();
    return (
        <div className="insights-novac-outer">
            <div className="insights-novac-header-section">
                <h1 className="insights-novac-title">
                    At Novac Technology Solutions, innovation meets people-first practices to create an outstanding workplaces.
                </h1>
            </div>
            <div className="insights-novac-mainrow">
                <div className="insights-novac-mainimg-container">
                    <img src="/assets/insights/novac.jpg" alt="Novac Technology Solutions" className="insights-novac-mainimg" />
                    <div className="insights-novac-badge">
                        <img src="/assets/Badge_TM.png" alt="Certified Badge" className="insights-novac-badge-imgmain" />
                    </div>
                </div>
                <div className="insights-novac-sidecard">
                    <div className="insights-novac-sidecard-badge">
                        <img src="/assets/Badge_TM.png" alt="Certified Badge" className="insights-novac-badge-img" />
                    </div>
                    <div className="insights-novac-sidecard-bg">
                        <img src="/assets/insights/novac_2.jpg" alt="Novac Team" />
                    </div>
                    <div className="insights-novac-sidecard-content">
                        <h3>Earn the Outstanding<br /><span>Workplaces Certification</span></h3>
                        <ul>
                            <li>Attract Top Talent</li>
                            <li>Boost Employee Engagement</li>
                            <li>Drive Culture-Led Growth</li>
                        </ul>
                        <button className="insights-novac-sidecard-btn" onClick={() => navigate('/nominate')}>Get Certificate</button>
                    </div>
                </div>
            </div>
            <div className="insights-novac-share">
                <span>Share :</span>
                <img
                    src="/icons/insightstwitter.png"
                    alt="Twitter"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        const url = encodeURIComponent(window.location.href);
                        window.open(`https://twitter.com/intent/tweet?url=${url}`, '_blank', 'noopener,noreferrer');
                    }}
                />
                <img
                    src="/icons/insightslinkedin.png"
                    alt="LinkedIn"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        const url = encodeURIComponent(window.location.href);
                        window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${url}`, '_blank', 'noopener,noreferrer');
                    }}
                />
                <img
                    src="/icons/insightsfacebook.png"
                    alt="Facebook"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        const url = encodeURIComponent(window.location.href);
                        window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank', 'noopener,noreferrer');
                    }}
                />
                <img
                    src="/icons/insightswhatsapp.png"
                    alt="WhatsApp"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        const url = encodeURIComponent(window.location.href);
                        window.open(`https://wa.me/?text=${url}`, '_blank', 'noopener,noreferrer');
                    }}
                />
            </div>
            <div className="insights-novac-content-section">
                <h2 className="insights-novac-content-title">At Outstanding Workplaces, we recognize organizations that build strong cultures through innovation, leadership, and meaningful employee experiences.</h2>
                <ul>
                    <li>Novac Technology Solutions exemplifies this approach by combining people-first values with cutting-edge technology to drive excellence across industries.</li>
                </ul>
                <h3>Building an Outstanding Workplace Through Innovation and Purpose</h3>
                <ul>
                    <li>Explore how Novac Technology Solutions blends innovation with a strong sense of purpose to create a workplace where people thrive and ideas flourish.</li>
                </ul>
                <h3>Inside Novac Technology Solutions: A Culture Driven by Creativity and Integrity</h3>
                <ul>
                    <li>A deep dive into Novac’s unique workplace culture, rooted in integrity, collaboration, and continuous innovation.</li>
                </ul>
                <h3>Leadership That Inspires: How Novac Nurtures Future-Ready Leaders</h3>
                <ul>
                    <li>Highlight internal leadership grooming practices, mentoring models, and growth opportunities for emerging leaders.</li>
                </ul>
                <h3>People-First Practices That Power Business Excellence</h3>
                <ul>
                    <li>Showcase how employee experience, wellbeing, and engagement directly contribute to Novac’s business success.</li>
                </ul>
                <h3>Innovation as a Mindset: Empowering Teams to Think Beyond Boundaries</h3>
                <ul>
                    <li>Discuss how Novac encourages experimentation, creativity, and adoption of emerging technologies across teams.</li>
                </ul>
                <h3>Learning, Growth, and Transformation at Novac Technology Solutions</h3>
                <ul>
                    <li>Focus on continuous learning initiatives, skill development, and career progression opportunities within the organization.</li>
                </ul>
                <h3>Creating Impact Across Industries Through a Strong Workplace Culture</h3>
                <ul>
                    <li>Connect Novac’s workplace practices with its success in Financial Services, Insurance, Digital Learning, and Immersive Technology.</li>
                </ul>
                <h3>From Talent to Leaders: Grooming Tomorrow’s Leadership Internally</h3>
                <ul>
                    <li>A dedicated piece on succession planning, internal promotions, and leadership development journeys at Novac.</li>
                </ul>
                <h3>Employee Experience at the Core: How Novac Shapes Everyday Work Life</h3>
                <ul>
                    <li>Highlight how culture, leadership accessibility, trust, and collaboration influence daily employee experiences.</li>
                </ul>
                <h3>The Future of Work at Novac: Innovation, Trust, and Sustainable Growth</h3>
                <ul>
                    <li>A forward-looking blog on how Novac is preparing its people and culture to meet future workplace challenges.</li>
                </ul>
            </div>
        </div>
    );
}
